  <app-input-dropdown [options]="displayOptions" [control]="displayControl" [shouldBeFullWidth]="false" [label]="'Display'" [inline]="true"></app-input-dropdown>
  <ng-template #checkNotCompleted>
            <span class="app-table-undefined-content">{{'Check not completed'|translation}}</span>
            </ng-template>
        <div class="configurable-table-holder" *ngIf="permissions.length; else checkNotCompleted">
        <table class="contrast-table">
            <thead>
                <tr>
                    <th>Permission</th>
                    <th>{{ showAccountPermissions ? 'root' : 'status' | translation | transformText: 'capitalize' }}</th>
                    <th *ngIf="showAccountPermissions">{{ 'account' | translation | transformText: 'capitalize' }}</th>
                    <th>Reason</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let permission of permissions" [ngClass]="{
                    'hidden': 
                    display === 'missing' && 
                    (permission.root !== 'required' && permission.root !== 'optional') && 
                    (permission.account !== 'required' && permission.account !== 'optional')
                    ||
                    display === 'required' && (permission.root !== 'required' && permission.root !== 'optional')                    
                    }">
                    <td>{{permission.title}}</td>
                    <td style="text-align: center;">
                        <i
                            class="fa-solid"
                            [pTooltip]="permission.root === 'available' ? 'Available' : permission.root === 'required' ? 'Required permission missing' : permission.root === 'optional' ? 'Recommended permission missing' : ''"
                            *ngIf="permission.root"
                            [ngClass]="{
                              active: permission.root === 'available'   ,
                              required: permission.root === 'required',
                              optional: permission.root === 'optional',
                              'fa-circle-check': permission.root === 'available',
                              'fa-circle-xmark': permission.root === 'required' || permission.root === 'optional'                     
                            }"
                        ></i>
                    </td>
                    <td style="text-align: center;" *ngIf="showAccountPermissions">
                        <i
                            class="fa-solid"
                            *ngIf="permission.account"
                            [pTooltip]="permission.account === 'available' ? 'Available' : permission.account === 'required' ? 'Required permission missing' : permission.account === 'optional' ? 'Recommended permission missing' : ''"
                        [ngClass]="{
                          active: permission.account === 'available',
                          required: permission.account === 'required'   ,
                          optional: permission.account === 'optional',
                          'fa-circle-check': permission.account === 'available',
                          'fa-circle-xmark': permission.account === 'required' || permission.account === 'optional'                     
                        }"
                      ></i></td>
                    <td [innerHTML]="permission.reason|safeHtml"></td>
                </tr>
            </tbody>
        </table>  
        </div>  
